import React from 'react';
import { useNavigate } from 'react-router-dom';
import { X } from 'lucide-react';

const FullModal = ({ children, onClose }) => {
  const navigate = useNavigate();

  const handleBackgroundClick = (e) => {
    if (e.target === e.currentTarget) {
      handleClose();
    }
  };

  const handleClose = () => {
    if (onClose) {
      onClose();
    } else {
      // Go back to previous page
      navigate(-1);
    }
  };

  return (
    <div className="page-modal-overlay" onClick={handleBackgroundClick}>
      <div className="page-modal-content">
        <button className="page-modal-close" onClick={handleClose}>
          <X size={20} />
        </button>
        <div className="page-modal-body">
          {children}
        </div>
      </div>
    </div>
  );
};

export default FullModal; 